import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserInputContext } from '../contexts/UserInputContext';
import { useAuth } from '../contexts/authContext';

function InputPage() {
  const navigate = useNavigate();
  const { inputText, setInputText } = useContext(UserInputContext);
  const [error, setError] = useState('');
  const [charCount, setCharCount] = useState(inputText.length);
  const { isLoggedIn } = useAuth(); // 로그인 여부 확인
  const maxLength = isLoggedIn ? 800 : 300; // 동적 최대 길이



  const handleNext = () => {
    if (!inputText.trim()) {
      setError('문장을 입력해주세요.');
      return;
    }
    setError('');
    navigate('/tone');
  };

    const handleChange = (e) => {
      const text = e.target.value;
      if (text.length <= maxLength) {
        setInputText(text);
        setCharCount(text.length);
      }
    };


  return (
      <div
          className="min-h-screen bg-gradient-to-b from-white to-blue-50 dark:from-gray-900 dark:to-gray-800 text-gray-800 dark:text-white flex flex-col items-center px-6 py-12">
          <h2 className="text-2xl sm:text-3xl font-extrabold text-blue-700 dark:text-blue-300 mb-4 text-center drop-shadow">
              전달하고 싶은 핵심 문장을 입력해주세요
          </h2>

          {/* 예시 박스 */}
          <div
              className="bg-white dark:bg-gray-800 border border-blue-100 dark:border-gray-600 text-gray-600 dark:text-gray-300 text-sm sm:text-base rounded-xl px-4 py-3 mb-6 max-w-xl shadow-sm">
              예시: <span className="text-gray-800 dark:text-white font-medium">"택배가 일주일째 도착하지 않았습니다"</span>
          </div>

          {/* 입력 박스 */}
            <textarea
              rows="5"
              value={inputText}
              onChange={handleChange}
              placeholder="여기에 문장을 입력하세요..."
              className="w-full max-w-xl p-4 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 text-base rounded-2xl shadow-md focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
            />

            {!isLoggedIn && (
              <p className="text-sm text-blue-500 mt-1 text-right max-w-xl w-full">
                  비회원은 <strong>300자</strong> 회원은 최대 <strong>800자</strong>까지 입력할 수 있습니다.
              </p>
            )}

            <p className="text-sm text-gray-500 mt-1 text-right max-w-xl w-full">
              {charCount} / {maxLength}자
            </p>

          {error && (
              <p className="text-red-500 text-sm mt-2">{error}</p>
          )}

          <button
              onClick={handleNext}
              className="mt-8 bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-2xl shadow-lg ring-2 ring-blue-300 transition"
          >
              👉 다음 단계로 이동
          </button>
          <br/>
          <p style={{
              fontSize: "0.9em",
              color: "gray",
              fontWeight: "bold",
              textAlign: "center"
          }}>
              일정 시간 사용하지 않으면 간혹 기능이 동작하지 않는 경우가 있습니다.<br/>
              약 1분 후에 화면을 새로고침 하신 후 다시 시도해 주세요.
              <br/>
              If you do not use it for a certain period of time, the function may not work occasionally.<br/>
              Please refresh the screen after about 1 minutes and try again.
          </p>
      </div>
  );
}

export default InputPage;
